import { Divider } from "@mui/material";
import React from "react";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Link } from "react-router-dom";

const LinksSection = () => {
  return (
    <div>
      <LinkMarquee />
    </div>
  );
};

const LinkMarquee = () => {
  const rehoLinks = [
    {
      id: 1,
      platformName: "Github",
      platformLink: "https://github.com/rehan-ankalgi-7t2",
    },
    {
      id: 2,
      platformName: "Stackoverflow",
      platformLink: "https://stackoverflow.com",
    },
    { id: 3, platformName: "Medium", platformLink: "https://medium.com" },
    { id: 4, platformName: "Linkedin", platformLink: "https://linkedin.com" },
    {
      id: 5,
      platformName: "Instagram",
      platformLink: "https://instagram.com/reho.dev",
    },
    { id: 6, platformName: "Twitter", platformLink: "https://twitter.com" },
    { id: 7, platformName: "Dribbble", platformLink: "https://dribbble.com" },
    { id: 8, platformName: "Behance", platformLink: "https://behance.com" },
  ];

  return (
    <div style={{ padding: "0px 24px", backgroundColor: "#090909" }}>
      {rehoLinks.map((r) => (
        <Link
          key={r.id}
          to={r.platformLink}
          style={{
            height: "80px",
            borderBottom: "2px solid white",
            backgroundColor: "#090909",
            color: "white",
            textTransform: "uppertext",
            fontSize: "24px",
            padding: "10px 0px",
            display: "flex",
            alignItems: "center",
            gap: "20px",
            justifyContent: "space-between",
            textDecoration: "none",
          }}
        >
          {r.platformName} <ArrowOutwardIcon />
        </Link>
      ))}
    </div>
  );
};

export default LinksSection;
